// extracted by mini-css-extract-plugin
export default {"buttonSize":"TitularExistenteModal_buttonSize__38LVA","textSize":"TitularExistenteModal_textSize__nmVVg"};